import { FormItem } from '@/components';
import { COLORS } from '@/theme';
import { TreeSelect } from 'antd';
import styled from 'styled-components';

export const StyledFormItem = styled(FormItem)`
  &&& .ant-form-item-control-input {
    max-width: 32.5rem;
  }

  &&& .ant-form-item-label label {
    color: ${COLORS.IRON_GRAY};
  }
`;

export const StyledTreeSelect = styled(TreeSelect)`
  width: 100%;
  text-align: left;
  height: 2.85rem;
`;
